import { Card, SimpleCollapse } from 'components'
import { COLORS, SPACING } from 'utils'

import {
  ManagementUnitTable,
  PlantCenterTable,
  RegistrationTable
} from './components'

export default function CockpitParameters() {
  return (
    <Card
      marginLeft={SPACING.spacing20}
      marginRight={SPACING.spacing20}
      marginBottom={SPACING.spacing100}
      padding={SPACING.spacing20}
      boxShadow={`0 0 1em ${COLORS.lightGray}`}
    >
      <SimpleCollapse title="Unidade Gestora (Centro Custo)">
        <ManagementUnitTable />
      </SimpleCollapse>

      <SimpleCollapse title="Centro Planta">
        <PlantCenterTable />
      </SimpleCollapse>

      <SimpleCollapse title="Matrícula">
        <RegistrationTable />
      </SimpleCollapse>
    </Card>
  )
}
